<template>
<div class="chapter">
<div class="inner_page">
<p class="ORIM-Book-Title"><span class="CharOverride-3">MURDER, STAGE LEFT</span></p>
<p class="ORIM-Book-Subtitle">A Nero Wolfe Mystery</p>
<p class="ORIM-Author-Name ParaOverride-3"><span class="CharOverride-4">Robert
				Goldsborough</span></p>
<p class="ORIM-Author-Name ParaOverride-3"><img src="image/logo3.jpg"/></p>
<p class="ORIM-Dedication">To Otto Penzler,<br/>Publisher and editor extraordinaire,
			<br/>for his continuing support and encouragement</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Title.vue?651be2fa